import { render, staticRenderFns } from "./TableHistory.vue?vue&type=template&id=0cb16f67&scoped=true"
import script from "./TableHistory.vue?vue&type=script&lang=js"
export * from "./TableHistory.vue?vue&type=script&lang=js"
import style0 from "./TableHistory.vue?vue&type=style&index=0&id=0cb16f67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb16f67",
  null
  
)

export default component.exports